import { h, Component, Fragment } from "preact";
import OptimizedListeners from "../../utils/optimized-listeners";
import Session from "../jamibet/utils/session";
import LiveFeed from "../../services/live-feed";
import CasinoFeed from "../../services/casino-feed";
import PageDataFeed from "../../services/page-data-feed";
import PrematchFeedService from "../../services/prematch-feed";
import TicketConfirmService from "../../services/ticket-confirm";

import Desktop from "./desktop-pages/index"
import Mobile from "./mobile-pages/index"

export default class Page extends Component {
    componentWillMount() {
        OptimizedListeners();
    }

    render({ config, path }) {
        return <Fragment>
            <Session />
            <LiveFeed />
			<PageDataFeed />
            <PrematchFeedService />
            <TicketConfirmService />
			<CasinoFeed />
			{!PageDataFeed.data.mobile 
				? <Desktop />
				: <Mobile /> }
        </Fragment>;
    }
}

//> Eof